export default __webpack_public_path__ + "static/media/carousel_3.3273e430.jpg";